module.exports = __webpack_public_path__ + "static/img/dl_MetaMask.d6a7b36f.png";